import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { Helmet } from "react-helmet-async";

import { getListCooperation, List } from "~/features/cooperation";
import { ErrorElement } from "~/components/ErrorElement";

const cooperationSearchSchema = z.object({
  page: z.number().catch(1),
  limit: z.number().catch(9),
  keyword: z.string().catch(""),
});

type CooperationSearch = z.infer<typeof cooperationSearchSchema>;

export const Route = createFileRoute("/_layout/cooperation/")({
  validateSearch: (search: Record<string, unknown>): CooperationSearch => cooperationSearchSchema.parse(search),
  loaderDeps: ({ search: { keyword, limit, page } }) => ({ keyword, limit, page }),
  loader: ({ context: { queryClient }, deps: { page, limit, keyword } }) =>
    queryClient.ensureQueryData(getListCooperation({ page, limit, keyword })),
  gcTime: 0,
  shouldReload: false,
  errorComponent: () => <ErrorElement statusCode="500" />,
  notFoundComponent: () => <ErrorElement statusCode="404" />,
  component: () => (
    <>
      <Helmet>
        <title>Data Koperasi - Ecobiz</title>
      </Helmet>
      <List />
    </>
  ),
});
